<template>
  <v-list style="margin-bottom: 100px">
    <div v-if="user.has_coach_license">
    <v-subheader>Coaching Tools</v-subheader>
    <nav-link 
      to="/dashboard" 
      icon="dashboard" 
      name="Coaching Dashboard"
      tutorial="G_dxifwbUU8" 
      />
    <nav-group title="Client Onboarding" icon="person_add">
      <nav-link to="/add-clients" name="Invite New Clients" />
      <!-- <nav-link to="/client-onboarding" name="Invite a Group of Clients" /> -->
      <nav-link to="/automated-registration" name="Set Up Subscription Plans" />
      <nav-link to="/client-onboarding" name="View Pending Client Invitations" />
      <tutorial @click="$emit('tutorial', 'mvRrZ3hTCqE')" />
    </nav-group>
    <nav-group title="Habit Programs" icon="group_work">
      <nav-link to="/habit-programs/new" name="Create a New Habit Program" />
      <nav-link to="/habit-programs" name="View/Edit Existing Habit Programs" />
      <tutorial @click="$emit('tutorial', 'TbPwc4uulV0')" />
    </nav-group>
    <nav-group title="Online Courses" icon="assignment" >
      <nav-link to="/courses/new"  name="Create a New Online Course" />
      <nav-link to="/coach-courses" name="View/Edit Existing Online Course" />
      <tutorial @click="$emit('tutorial', 'y9sdkbnGTe0')" />
    </nav-group>
    <nav-group title="Pulse Surveys"  icon="assessment">
      <nav-link to="/pulse-surveys-new" name="Create a New Pulse Survey" />
      <nav-link to="/pulse-surveys" name="View/Edit Existing Pulse Surveys" />
      <tutorial @click="$emit('tutorial', 'DNke--O0TRM')" />
    </nav-group>
    <nav-group title="Assessments" icon="score"  >
      <nav-link routeName="coachAssessmentLibrary" name="Assessment Library" />
      <nav-link to="/coach/assessment-distribute" name="Distribute An Assessment" />
      <nav-link to="/coach/assessment/creation" name="Create a Custom Assessment" />
      <nav-link routeName="coachAssessments" name="Review Assessment Results" />
      <tutorial @click="$emit('tutorial', '7oq-PcFg414')" />
    </nav-group>
    <nav-group title="Cohorts" icon="show_chart">
      <nav-link to="/cohorts/new" name="Create a Cohort" />
      <nav-link to="/cohorts" name="Review Existing Cohort" />
      <tutorial @click="$emit('tutorial', '7sjvn3wuPvI')" />
    </nav-group>
    <message-counter />
    <nav-link
      to="/site-management/settings"
      icon="settings"
      name="Site Settings"
      tutorial="tjpI0aeU2TM"
      />

    <v-subheader>Client Tools</v-subheader>
    </div>
    <client-nav :notificationColor="notificationColor" :user="user" />

    <v-divider></v-divider>
    <nav-link to="/settings" icon="settings" name="Settings" />
    <v-list-tile @click="logout" class="end-section">
      <v-list-tile-avatar>
        <h-icon>close</h-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>Log Out</v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import modal from "@/components/modal";
import nav from "./nav";
import messageCounter from "@/components/messages/counter";
import clientNav from "./clientNav";
import navGroup from "./navGroup";
import tutorial from "./tutorial";

export default {
  props: ["user", "subDomain", "notificationColor"],
  components: { navLink: nav, messageCounter, clientNav, navGroup, tutorial, modal },
  created() {
    // this.$eventHub.$emit("tutorial", "nav");
  },
  methods: {
    logout() {
      this.$emit("logout");
    }
  },
};
</script>
